module.exports = __webpack_public_path__ + "static/media/ngo.f93b5e87.jpg";